export const MODAL_IS_OPEN = 'MODAL_IS_OPEN';

export function changeModalState(data) {
  return {
    type: MODAL_IS_OPEN,
    payload: data,
  }
}


// WEBPACK FOOTER //
// ./src/actions/modal/index.js